/**
 * "1 sale", "2 sales", "0 sales". Pass `plural` for irregular words
 * ("1 patient", "3 people").
 */
export function pluralize(
  count: number | null | undefined,
  singular: string,
  plural = `${singular}s`,
): string {
  const n = count ?? 0;
  return `${n} ${n === 1 ? singular : plural}`;
}
